import { u_ } from "@pressmedia/webappbase";

export default {
	// コンテンツのキー
	_dk: "",
	
	/**
	* dataKeyの取得
	* @return string
	*/
	getDataKey() {
		return this._dk;
	},
	
	/**
	* dataKeyのセット
	* @return this
	*/
	setDataKey(dataKey) {
		this._dk = u_.isString(dataKey) ? dataKey : "";
		
		if(this._dk) {
			this.items = {};
			
			// データ取得時のフィルタ設定
			u_.isObject(this.getFilter) || (this.getFilter = {});
			
		} else {
			delete this.items;
			delete this.getFilter;
		}
		
		return this;
	}
};
